import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const Text = styled.div`
  font-size: var(--font-size-400);
  line-height: var(--font-line-height-400);
  letter-spacing: var(--font-letter-spacing-normal);
  margin-top: var(--space-300);
`

export const ButtonsContainer = styled.div`
  width: 100%;
  margin-top: var(--space-600);
  gap: var(--space-300);
  display: flex;
  flex-direction: column;
`
